export const EXPLORARFICHA_LOADING = 'EXPLORARFICHA_LOADING';
export const EXPLORARFICHA_LOADED = 'EXPLORARFICHA_LOADED';
export const EXPLORARFICHA_ERROR = 'EXPLORARFICHA_ERROR';

export const EXPLORARHOME1_LOADING = 'EXPLORARHOME1_LOADING';
export const EXPLORARHOME1_LOADED = 'EXPLORARHOME1_LOADED';
export const EXPLORARHOME1_ERROR = 'EXPLORARHOME1_ERROR';

export const EXPLORARFICHAINDI_LOADING = 'EXPLORARFICHAINDI_LOADING';
export const EXPLORARFICHAINDI_LOADED = 'EXPLORARFICHAINDI_LOADED';
export const EXPLORARFICHAINDI_ERROR = 'EXPLORARFICHAINDI_ERROR';

export const SLIDERS_LOADING = 'SLIDERS_LOADING';
export const SLIDERS_LOADED = 'SLIDERS_LOADED';
export const SLIDERS_ERROR = 'SLIDERS_ERROR';